import { ComboRequestDto, restRepository } from "@onair/repositories";

export interface GetCombosParams {
	/**
	 * @max 25
	 * @default 10
	 */
	take: number;
	/** @default 0 */
	skip: number;
	discountType?: "PERCENTAGE" | "AMOUNT";
	isActive?: boolean;
	searchValue?: string;
	status?: "going_on" | "coming" | "expired";
}

export interface GetComboProductParams {
	/**
	 * @max 25
	 * @default 10
	 */
	take: number;
	/** @default 0 */
	skip: number;
	type?: "EVENT";
	searchValue?: string;
	comboId?: string;
}

export interface GetComboBuyerParams {
	/**
	 * @max 25
	 * @default 10
	 */
	take: number;
	/** @default 0 */
	skip: number;
	comboId: string;
	searchValue?: string;
}

const getCombos = async (query: GetCombosParams) => {
	const response = await restRepository.api.comboControllerGetCombos(query);
	return response.data;
};

const getComboById = async (id: string) => {
	const response = await restRepository.api.comboControllerGetCombo(id);
	return response.data;
};

const getComboBySlug = async (slug: string) => {
	const response = await restRepository.api.comboControllerGetComboBySlug(slug);
	return response.data;
};

const getCombosByUserId = async (userId: string) => {
	const response = await restRepository.api.getCombosByUserId(userId);
	return response.data;
};

const getComboRecommendations = async (slug: string) => {
	const response =
		await restRepository.api.comboControllerGetComboRecommendation(slug);
	return response.data;
};

const getAvailableProducts = async (query: GetComboProductParams) => {
	const response =
		await restRepository.api.comboControllerAvailableProduct(query);
	return response.data;
};

const createCombo = async (data: ComboRequestDto) => {
	const response = await restRepository.api.comboControllerCreateCombo(data);
	return response.data;
};

const updateCombo = async (id: string, data: ComboRequestDto) => {
	const response = await restRepository.api.comboControllerUpdateCombo(
		id,
		data,
	);
	return response.data;
};

const changeStatusCombo = async (id: string) => {
	const response = await restRepository.api.comboControllerChangeComboState(id);
	return response.data;
};

const deleteCombo = async (id: string) => {
	const response = await restRepository.api.comboControllerDeleteCombo(id);
	return response.data;
};

const getComboBuyers = async (query: GetComboBuyerParams) => {
	const response = await restRepository.api.comboControllerGetBuyers(query);
	return response.data;
};

const getCombosForProduct = async (productId: string) => {
	const response =
		await restRepository.api.comboControllerGetCombosForProduct(productId);
	return response.data;
};

const validateComboPurchase = async (comboId: string) => {
	const response = await restRepository.api.validateComboPurchase(comboId);
	return response.data;
};

export {
	getCombos,
	getComboById,
	getAvailableProducts,
	createCombo,
	updateCombo,
	changeStatusCombo,
	deleteCombo,
	getComboBuyers,
	getCombosForProduct,
	getComboBySlug,
	getComboRecommendations,
	getCombosByUserId,
	validateComboPurchase
};
